<script>
	import { blur } from "svelte/transition";
	import { metatags } from "@roxi/routify";
	$: metatags.title = `Mustafa Gülsün - Front-end Developer`;

	const randomIntFromInterval = (min, max) =>
		Math.floor(Math.random() * (max - min + 1) + min);

	const hellos = ["Hola!", "Hello!", "Merhaba!"];
	let hello = hellos[0];

	setInterval(() => {
		hello = hellos[randomIntFromInterval(0, hellos.length - 1)];
	}, 1000);

	const tags = [
		{
			name: "Some of the techs I use and follow are:",
			tags: [
				"Javascript",
				"Node.js",
				"Vue.js",
				"Vite",
				"Svelte",
				"CSS",
				"PostCSS",
				"Webpack",
				"A11Y",
				"Cypress",
				"PUG",
			],
		},
		{
			name: "Learning in progress:",
			tags: ["React", "React Native", "Phython", "Machine Learning"],
		},
		// { name: "Deprecated:", tags: ["PHP", "Wordpress"] },
	];
</script>

<main id="main" tabindex="-1">
	<section class="hero is-fullheight is-primary">
		<div class="container">
			<div class="fade-animation">
				{#key hello}
					<h1 class="hero-heading" transition:blur>{hello}</h1>
				{/key}
			</div>
			<p class="lead">
				I am <strong>Mustafa Gülsün</strong> <em>&amp;</em> I am a front-end developer.
			</p>
			{#each tags as tag}
				<p>{tag.name}</p>
				<ul class="tags">
					{#each tag.tags as label}
						<li>{label}</li>
					{/each}
				</ul>
			{/each}
		</div>
	</section>
</main>

<style>
	.lead {
		font-size: 2rem;
		line-height: 1em;
	}

	.lead strong {
		text-decoration: underline;
	}

	.fade-animation {
		position: relative;
		height: 4rem;
	}

	.hero-heading {
		font-size: 4rem;
		margin: 0;
		position: absolute;
	}

	.hero .tags {
		display: flex;
		flex-wrap: wrap;
		list-style: none;
		padding: 0;
	}

	.hero .tags li {
		color: var(--bg-primary);
		background-color: var(--text-primary);
		border-radius: 1rem;
		padding: 8px 12px;
		margin: 4px;
		transition: all ease-in 200ms;
	}

	.hero .tags li:hover {
		background-color: var(--bg-hover-primary);
		color: var(--text-hover-primary);
	}

	.hero .tags li:first-child {
		margin-left: 0;
	}
</style>
